import classNames from "classnames";
import React from "react";

const TemplateContainer = ({
  children,
  className,
  style,
  isSuperUserFeature,
}: {
  children: any;
  className?: string;
  style?: any;
  isSuperUserFeature?: boolean;
}) => {
  return (
    <div
      className={classNames(
        "w-full border-subtle rounded-lg border py-6 px-4 sm:px-6",
        {
          "bg-yellow-50 border-yellow-300": isSuperUserFeature,
        },
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
};

export default TemplateContainer;
